import styled from 'styled-components';

export const ExceptionsHeaderContainer = styled.div<{size?: 'fixed' | 'small'}>`
  display: flex;
  flex-direction: row;
  margin-left: 43px;

  ${({ size }) => (size === 'fixed' ? `
    justify-content: space-between;
    width: auto;
    margin-left: 20px;
  ` : '')}

  @media (max-width: 768px) {
    width: 709px;

    & > div {
      width: auto;
    }
  }

`;
